
  import axios from "axios";
  import React, { useContext, useEffect, useState } from "react";
  import { FaCircle } from "react-icons/fa";
  import { useNavigate } from "react-router";
  import { CommonContext } from "../../App";
  import { SiGoogletagmanager } from "react-icons/si";
  import { useTranslation } from "react-i18next";
  import LoadingSpinner from "../../Components/CommonComponent/loadingSpiner/LoadingSpinner";
  import api from "../../services/api";


  export default function ProfitAndLoss() {
    const { t } = useTranslation();
    const todayDate = new Date();
    const formatDate = (date) => date.toISOString().split("T")[0];
    const navigate = useNavigate();

  
    const { branchId, dateRange } = useContext(CommonContext);

    const [startDate, setStartDate] = useState(dateRange.startDate);
    const [endDate, setEndDate] = useState(dateRange.endDate);
    const [loading, setLoading] = useState(false);
    const [branchSheets, setBranchSheets] = useState([]);
    const [expandedGroups, setExpandedGroups] = useState({});
           const storedLang = JSON.parse(localStorage.getItem("second_language"));
   const language = storedLang?.language || "en";

    // Sync with global date range
    useEffect(() => {
      setStartDate(dateRange.startDate);
      setEndDate(dateRange.endDate);
    }, [dateRange.startDate, dateRange.endDate]);

    // Fetch data
    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await api.get(`ledgers/get-trial-summary`, {
            params: { startDate, endDate, branchId },
          });

          if (res.data.success) {
            const formattedBranches = res.data.data.map((branchBlock) => {
              const { branchId, branchName, branchData } = branchBlock;

              const processedRows = (branchData || []).map((ledger) => {
                const {
                  id,
                  groupName,
                  groupNameInHindi,
                  subGroupName,
                  subGroupNameInHindi,
                  name,
                  groupType,
                  totalReceived = 0,
                  totalPaid = 0
                } = ledger;

                const debit =
                  totalReceived > totalPaid ? totalReceived - totalPaid : 0;
                const credit =
                  totalPaid > totalReceived ? totalPaid - totalReceived : 0;

                return {
                  id,
                  groupName: groupName || null,
                  groupNameInHindi:groupNameInHindi || null,
                  subGroupName: subGroupName || null,
                  subGroupNameInHindi:subGroupNameInHindi || null,
                  account: name,
                  debit,
                  credit,
                  type: groupType || "",
                };
              });

              return {
                branchId,
                branchName,
                rows: processedRows,
              };
            });

            setBranchSheets(formattedBranches);
          } else {
            setBranchSheets([]);
          }
        } catch (error) {
          console.error("Error fetching trial balance:", error);
          setBranchSheets([]);
        } finally {
          setLoading(false);
        }
      };

      if (startDate && endDate && branchId) {

      fetchData();}
    }, [startDate, endDate, branchId]);

    // Grouping Logic
    // const groupData = (rows, type) => {
    //   const grouped = {};
    //   rows.forEach((r) => {
    //     const g = r.groupName || "Ungrouped";
    //     const sg = r.subGroupName || null;

    //     if (!grouped[g]) grouped[g] = {};

    //     if (sg) {
    //       if (!grouped[g][sg]) grouped[g][sg] = [];
    //       grouped[g][sg].push(r);
    //     } else {
    //       if (!grouped[g]["__noSubGroup__"]) grouped[g]["__noSubGroup__"] = [];
    //       grouped[g]["__noSubGroup__"].push(r);
    //     }
    //   });
    //   return grouped;
    // };
    const groupData = (rows) => {
  const grouped = {};

  rows.forEach((r) => {
    const gKey = r.groupName || "Ungrouped";

    if (!grouped[gKey]) {
      grouped[gKey] = {
        groupName: r.groupName,
        groupNameInHindi: r.groupNameInHindi,
        subGroups: {},
      };
    }

    const sgKey = r.subGroupName || "__noSubGroup__";

    if (!grouped[gKey].subGroups[sgKey]) {
      grouped[gKey].subGroups[sgKey] = {
        subGroupName: r.subGroupName,
        subGroupNameInHindi: r.subGroupNameInHindi,
        rows: [],
      };
    }

    grouped[gKey].subGroups[sgKey].rows.push(r);
  });

  return grouped;
};


    const toggleGroup = (name) => {
      setExpandedGroups((prev) => ({
        ...prev,
        [name]: !prev[name],
      }));
    };

    // Table Renderer
    // const renderTable = (data, type) => (
    //   <table className="w-full border-collapse">
    //     <thead>
    //       <tr className="border-b font-bold">
    //         {/* <th className="p-1 text-left">{t("groups&SubGroups")}</th>
    //         <th className="p-1 text-right">{t("amount")} (₹)</th> */}
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {Object.keys(data).map((group) => {
    //         const groupObj = data[group];
    //         const hasSubGroups = Object.keys(groupObj).some(
    //           (k) => k !== "__noSubGroup__"
    //         );

    //         const groupTotal = Object.values(groupObj)
    //           .flat()
    //           .reduce(
    //             (sum, r) => sum + (type === "Expense" ? r.debit : r.credit),
    //             0
    //           );

    //         return (
    //           <React.Fragment key={group}>
    //             <tr
    //               className={` text-sm ${
    //                 hasSubGroups
    //                   ? "bg-gray-50 cursor-pointer hover:bg-gray-100 border-t"
    //                   : "bg-gray-50"
    //               }`}
    //               onClick={() => hasSubGroups && toggleGroup(group)}
    //             >
    //               <td className="p-1 flex items-center">
    //                 {group} {group.groupNameInHindi}

    //                 {hasSubGroups && (
    //                   <span
    //                     className={`text-[9.5px] ml-2 ${
    //                       expandedGroups[group] ? "rotate-90" : ""
    //                     }`}
    //                   >
    //                     {expandedGroups[group] ? "▲" : "▼"}
    //                   </span>
    //                 )}
    //               </td>
    //               <td className="p-1 text-right">
    //                 {groupTotal.toLocaleString("en-IN")}
    //               </td>
    //             </tr>

    //             {hasSubGroups &&
    //               expandedGroups[group] &&
    //               Object.keys(groupObj)
    //                 .filter((sg) => sg !== "__noSubGroup__")
    //                 .map((sg) => {
    //                   const subRows = groupObj[sg];
    //                   const subTotal = subRows.reduce(
    //                     (sum, r) =>
    //                       sum + (type === "Expense" ? r.debit : r.credit),
    //                     0
    //                   );
    //                   return (
    //                     <tr key={sg} className="bg-gray-50 hover:bg-gray-100 text-sm">
    //                       <td className="px-5 pl-6 flex items-center text-sm gap-1">
    //                         <FaCircle className="text-[7px]" />
    //                         <div
    //                           className="cursor-pointer"
    //                           onClick={() => {
    //                             navigate(`/account-books/ledgers-table`, {
    //                               state: {
    //                                 ledger: { groupName: group, groupType: type },
    //                                 btnHeading: "Profit & Loss",
    //                                 btnlink: "/reports/profit-loss",
    //                               },
    //                             });
    //                           }}
    //                         >
    //                           {sg}
    //                         </div>
    //                       </td>
    //                       <td className="p-1 text-right">
    //                         {subTotal.toLocaleString("en-IN")}
    //                       </td>
    //                     </tr>
    //                   );
    //                 })}
    //           </React.Fragment>
    //         );
    //       })}
    //     </tbody>
    //   </table>
    // );
    const renderTable = (data, type) => (
  <table className="w-full border-collapse">
      <thead>
        <tr className="border-b  text-theme-headerBg text-sm  border-theme-headerBg">
          <th className="px-1 font-semibold py-[2px]  text-left">{t("ledger/account")}</th>
          <th className="px-1 font-semibold py-[2px]  text-right">{t("amount")} (₹)</th>
        </tr>
      </thead>
    <tbody>
      {Object.keys(data).map((groupKey) => {
        const group = data[groupKey];
        const subGroups = group.subGroups;

        const hasSubGroups = Object.keys(subGroups).some(
          (k) => k !== "__noSubGroup__"
        );

        const groupTotal = Object.values(subGroups)
          .flatMap((sg) => sg.rows)
          .reduce(
            (sum, r) => sum + (type === "Expense" ? r.debit : r.credit),
            0
          );

        return (
          <React.Fragment key={groupKey}>
            {/* GROUP ROW */}
            <tr
              className={`text-sm ${
                hasSubGroups
                  ? "bg-theme-tableBg cursor-pointer hover:bg-theme-tableHoverColor border-b"
                  : "bg-theme-tableBg"
              }`}
              onClick={() => hasSubGroups && toggleGroup(groupKey)}
            >
              <td className="p-1 flex py-[2px] items-center gap-1">
                <span>
                  {group.groupName}
                  {language !== "en" && (group.groupNameInHindi && (
                    <span className="  ml-1">
                      {group.groupNameInHindi}
                    </span>
                  ))}
                </span>

                {hasSubGroups && (
                  <span className="text-[9.5px] ml-2">
                    {expandedGroups[groupKey] ? "▲" : "▼"}
                  </span>
                )}
              </td>
              <td className="p-1 text-right">
                {groupTotal.toLocaleString("en-IN")}
              </td>
            </tr>

            {/* SUB GROUP ROWS */}
            {hasSubGroups &&
              expandedGroups[groupKey] &&
              Object.keys(subGroups)
                .filter((sgKey) => sgKey !== "__noSubGroup__")
                .map((sgKey) => {
                  const sg = subGroups[sgKey];

                  const subTotal = sg.rows.reduce(
                    (sum, r) =>
                      sum + (type === "Expense" ? r.debit : r.credit),
                    0
                  );

                  return (
                    <tr
                      key={sgKey}
                      className="bg-theme-tableBg cursor-pointer hover:bg-theme-tableHoverColor border-b text-sm"
                    >
                      <td className="px-5 pl-6 py-[2px] flex items-center gap-1">
                        <FaCircle className="text-[7px]" />
                        <div
                          className="cursor-pointer"
                          onClick={() =>
                            navigate(`/account-books/ledgers-table`, {
                              state: {
                                ledger: {
                                  groupName: group.groupName,
                                  subGroupName: sg.subGroupName,
                                  groupType: type,
                                },
                                btnHeading: "Profit & Loss",
                                btnlink: "/reports/profit-loss",
                              },
                            })
                          }
                        >
                          {sg.subGroupName}
                          {language !== "en" && (sg.subGroupNameInHindi && (
                            <span className="  ml-1">
                             {sg.subGroupNameInHindi}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td className="p-1 text-right">
                        {subTotal.toLocaleString("en-IN")}
                      </td>
                    </tr>
                  );
                })}
          </React.Fragment>
        );
      })}
    </tbody>
  </table>
);


    // Check if no data at all for all branches
    const allEmpty =
      branchSheets.length === 0 ||
      branchSheets.every((b) => {
        if (!b.rows || b.rows.length === 0) return true;
        const hasIncome = b.rows.some((r) => r.type === "Income");
        const hasExpense = b.rows.some((r) => r.type === "Expense");
        return !hasIncome && !hasExpense;
      });

    return (
      <div className=" mt-2 bg-white shadow-sm rounded-1 p-2">
        
        {/* Header */}
        <div className="flex justify-between rounded-1  bg-theme-headerBg text-theme-color px-2 py-1 mb-1">
          <div className=" font-medium ">{t("profitLossStatement")}</div>
        </div>

        {/* Loading Spinner */} 
        {loading && (
          <div className="flex justify-center py-6">
            <LoadingSpinner size={70} color="#000000" />
          </div>
        )}

        {/* Show "No Data" only when not loading */}
     

        {/* Branch Data */}
        {!loading &&
          branchSheets.map((branch) => {
            const rows = branch.rows || [];
            const incomeRows = rows.filter((r) => r.type === "Income");
            const expenseRows = rows.filter((r) => r.type === "Expense");

            // If branch has no data, show only name + message
            if (loading && incomeRows.length === 0 && expenseRows.length === 0) {
              return (
                <div key={branch.branchId} className="mb-1">
                  <div className="  mb-1 text-theme-headerBg  font-serif capitalize flex justify-center gap-1 px-1">
                    <div className="border-b border-theme-sidebarBg">
                      {branch.branchName}
                    </div>
                  </div>
                  <div className="text-gray-500 py-3 text-center text-sm">{t("noDataAvailable")}</div>
                </div>
              );
            }

            const incomeGrouped = groupData(incomeRows, "Income");
            const expenseGrouped = groupData(expenseRows, "Expense");

            const totalIncome = incomeRows.reduce(
              (sum, r) => sum + (r.credit || 0),
              0
            );
            const totalExpense = expenseRows.reduce(
              (sum, r) => sum + (r.debit || 0),
              0
            );
            const netProfit = Math.abs(totalIncome - totalExpense);

            return (
              <div key={branch.branchId} className="mb-1 pb-2 ">
                <div className=" text-theme-headerBg font-medium font-serif capitalize mb-1  flex justify-center gap-1 px-1" >
               <div className="border-b border-theme-sidebarBg ">
                 {branch.branchName}
               </div>
                
                </div>

                <div className="flex gap-2 pt-1">
                  <div className="w-1/2">
                    <div className="font-semibold text-sm px-1 py-[2px]  bg-theme-headerBg text-theme-color">
                      {t("expense")}
                    </div>
                    {renderTable(expenseGrouped, "Expense")}
                  </div>

                  <div className="w-1/2">
                    <div className="font-semibold text-sm px-2 py-[2px]  bg-theme-headerBg text-theme-color">
                      {t("income")}
                    </div>
                    {renderTable(incomeGrouped, "Income")}
                  </div>
                </div>

                {/* FOOTER — Show only when data exists */}
                {(incomeRows.length > 0 || expenseRows.length > 0) && (
                  <>
                    <div className="flex mt-3 text-theme-headerBg">
                      <div className="w-1/2 pe-2">
                        <div className="border-t border-theme-headerBg flex justify-between  px-1 pt-2 font-semibold text-sm">
                          <div>{t("total")}</div>
                          <div>{totalExpense.toLocaleString("en-IN")}</div>
                        </div>
                      </div>

                      <div className="w-1/2 ps-3">
                        <div className="border-t border-theme-headerBg flex justify-between px-1 pt-2 text-sm font-semibold">
                          <div>{t("total")}</div>
                          <div>{totalIncome.toLocaleString("en-IN")}</div>
                        </div>
                      </div>
                    </div>

                   <div
                      className={`mt-2 text-right font-bold text-sm border-t border-theme-headerBg pt-2 ${
                        totalIncome >= totalExpense
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {totalIncome >= totalExpense
                        ? t("netProfit")
                        : t("netLoss")} 
                      : ₹ {netProfit.toLocaleString("en-IN")}
                    </div>
                  </>
                )}
              </div>
            );
          })}
      </div>
    );
  }

